<div class="row">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Poncho(g/kg)</mat-label>
                <input matInput id="txtPoncho" #txtPoncho maxlength="10" formControlName="poncho" currencyMask readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalcTipoTrat}}</mat-hint>
                <mat-hint align="end">{{txtPoncho.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.poncho)}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Cruiser(g/kg)</mat-label>
                <input matInput id="txtCruiser" #txtCruiser maxlength="10" formControlName="cruiser" currencyMask readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalcTipoTrat}}</mat-hint>
                <mat-hint align="end">{{txtCruiser.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.cruiser)}}
                </mat-error>
              </mat-form-field>
            </div> -->
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Dermacor (g/kg)</mat-label>
                <input matInput id="txtDermacor" #txtDermacor maxlength="10" formControlName="dermacor" currencyMask
                  readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalcTipoTrat}}</mat-hint>
                <mat-hint align="end">{{txtDermacor.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.dermacor)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Redigo (g/kg)</mat-label>
                <input matInput id="txtRedigo" #txtRedigo maxlength="10" formControlName="redigo" currencyMask readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalcTipoTrat}}</mat-hint>
                <mat-hint align="end">{{txtRedigo.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.redigo)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Água (L/t)</mat-label>
                <input matInput id="txtAgua" #txtAgua maxlength="10" formControlName="agua" currencyMask [min]="0"
                  [max]="4" [options]="{ thousands: '.', decimal: ',', precision: 1, allowNegative: false  }"
                  [readOnly]="isReadOnlyAgua" [class.InputBlockColor]="isReadOnlyAgua" (blur)="changePolimero()">

                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyAgua"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyAgua"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtAgua.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.agua)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Polímero (L/t)</mat-label>
                <input matInput id="txtPolimero" #txtPolimero maxlength="10" formControlName="polimero" [min]="2.5"
                  [max]="6" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 1, allowNegative: false  }"
                  [readOnly]="isReadOnlyPolimero" [class.InputBlockColor]="isReadOnlyPolimero"
                  (blur)="changePolimero()">

                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyPolimero"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyPolimero"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPolimero.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.polimero)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Polímero</mat-label>
                <mat-select #txtPolimeroList formControlName="polimero_list" disableCenteringOption
                  (selectionChange)="changePolimero()" [readOnly]="isReadOnlyPolimero"
                  [class.InputBlockColor]="isReadOnlyPolimero">

                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPolimero($event.target.value)">
                  <mat-option *ngFor="let item of listOptionsPolimero" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyPolimero"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyPolimero"></i>

              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Calda TSI (g/Kg)</mat-label>
                <input matInput id="txtCaldaTsi" #txtCaldaTsi maxlength="10" formControlName="calda_tsi" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" [class.InputBlockColor]="true"
                  [readonly]="true">

                <!-- <i matSuffix class="{{iconEnableField}}"></i> -->
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtCaldaTsi.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.calda_tsi)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}"
                [ngClass]='{"mat-form-field-invalid": formulario.controls.calda_convencional.warning}'>
                <mat-label class="InputLabelColor">Calda Convencional (L/t)</mat-label>
                <input matInput id="txtCaldaConv" #txtCaldaConv maxlength="10" formControlName="calda_convencional"
                  [min]="0" [max]="15" [options]="{ thousands: '.', decimal: ',', precision: 2 }" currencyMask
                  [readOnly]="isReadOnlyCaldaConvencional" [class.InputBlockColor]="isReadOnlyCaldaConvencional"
                  (keypress)="verifyFormValuesMaxMin($event)" (blur)="verifyCaldaConvencional()">

                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyCaldaConvencional"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyCaldaConvencional"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCaldaConv.value.length}} / 10</mat-hint>

                <mat-error>{{hasErrorFormControl(formulario.controls.calda_convencional)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">ID Calda Base</mat-label>
                <input matInput id="txtIdCaldaBase" #txtIdCaldaBase maxlength="10" formControlName="id_calda_base"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtIdCaldaBase.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.id_calda_base)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>